<template>
  <b-modal class="modal-lg" id="disputeModal" ref="dispute-modal" :title="t('sendDisputeModalTitle', 'sendDisputeModalTitle')" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary"  @show="getDisputeStatuses(); setFirstDocument(); clearResponseMessage()" @hide="resetModal('main');clearModal();">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'comments']" size="1x" class="mr-2"/>{{ t('sendDisputeModalTitle', 'sendDisputeModalTitle') }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close();resetModal(queryModal.modalData.level);"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <div class="vld-parent text-center">
        <div autofocus>
            <loading
            :active.sync="modalIsBusy"
            :can-cancel="false"
            :color="'#047bf8'"
            :loader="'dots'"
            :is-full-page="false"></loading>
          <div v-if="!modalIsBusy" >
            <template v-if="queryModal.docuData.statuses && queryModal.docuData.docsChecked.length">
              <b-card no-body>
                <b-tabs id="query-tabs" pills card vertical active-nav-item-class="text-uppercase doc-button">
                  <b-tab @click="setSelectedDoc(doc.reference, doc.docId)" v-for="doc in queryModal.docuData.statuses" v-bind:key="'tab_'+ doc.docId" :title="doc.reference">
                    <h5 class="">{{ t('documentReferenceText', 'documentReferenceText') }}: {{ doc.reference }}</h5>
                    <div class="form-row" v-if="disputeStatuses">
                      <select class="form-control" v-model="selectedDisputeStatus" @change="checkDisputeRequirements()">
                        <option :value="null">{{ t('selectDisputeStatusText', 'selectDisputeStatusText') }}</option>
                        <option v-for="status in disputeStatuses" :key="status.id" :value="status.id">{{ status.status }}</option>
                      </select>
                    </div>
                    <div class="form-row" v-else>
                      <h4>{{ t('noDisputeStatusesAvailable', 'noDisputeStatusesAvailable') }}</h4>
                    </div>
                    <div class="form-row mt-2">
                      <label :for="'query-nature-' + doc.docId" class="d-block">{{t('sendDisputeNoteLabel','sendDisputeNoteLabel') }}</label>
                      <b-form-textarea :id="'query-nature-' + doc.docId" v-model="disputeNote" class="form-control col-12" rows="5" max-rows="5">
                      </b-form-textarea>
                    </div>
                    <p>{{t('sendDisputeNoteDesc', 'sendDisputeNoteDesc')}}</p>
                    <div v-if="selectedDisputeStatus">
                      <div v-if="reqAdditionalInfo1" class="form-row mt-2">
                        <label v-if="selectedDisputeStatus == 2" class="d-block">{{t('disputeCorrectPONumberLabel','disputeCorrectPONumberLabel') }}<span style="color: red; font-weigth: 600;">*</span></label>
                        <label v-if="selectedDisputeStatus == 4" class="d-block">{{t('disputeDuplicateOfInvoiceLabel','disputeDuplicateOfInvoiceLabel') }}<span style="color: red; font-weigth: 600;">*</span></label>
                        <label v-if="selectedDisputeStatus == 7" class="d-block">{{t('disputeWhoHasPaidLabel','disputeWhoHasPaidLabel') }}<span style="color: red; font-weigth: 600;">*</span></label>
                        <label v-if="selectedDisputeStatus == 10" class="d-block">{{t('disputeIncorrectItemsLabel','disputeIncorrectItemsLabel') }}<span style="color: red; font-weigth: 600;">*</span></label>
                        <label v-if="selectedDisputeStatus == 11" class="d-block">{{t('disputeWarrantyCoveredItemLabel','disputeWarrantyCoveredItemLabel') }}<span style="color: red; font-weigth: 600;">*</span></label>
                        <b-form-textarea v-model="additionalInfo1" class="form-control col-12" rows="3" max-rows="5">
                        </b-form-textarea>
                      </div>
                      <div v-if="reqAdditionalInfo2" class="form-row mt-2">
                        <label v-if="selectedDisputeStatus == 7" class="d-block">{{t('disputeDatePaidLabel','disputeDatePaidLabel') }}<span style="color: red; font-weigth: 600;">*</span></label>
                        <label v-if="selectedDisputeStatus == 10" class="d-block">{{t('disputeCorrectPriceLabel','disputeCorrectPriceLabel') }}<span style="color: red; font-weigth: 600;">*</span></label>
                        <template v-if="selectedDisputeStatus == 7">
                           <datePicker id="disputePaidDate" v-model="additionalInfo2" class="form-control" :config="datePickerConfig"></datePicker>
                        </template>
                        <template v-else>
                          <b-form-textarea v-model="additionalInfo2" class="form-control col-12" rows="3" max-rows="5">
                          </b-form-textarea>
                        </template>
                      </div>
                      <div v-if="reqAdditionalInfo3" class="form-row mt-2">
                        <label v-if="selectedDisputeStatus == 7" class="d-block">{{t('disputePaidByCheckNumberLabel','disputePaidByCheckNumberLabel') }}<span style="color: red; font-weigth: 600;">*</span></label>
                        <b-form-textarea v-model="additionalInfo3" class="form-control col-12" rows="3" max-rows="5">
                        </b-form-textarea>
                      </div>
                    </div>
                  </b-tab>
                </b-tabs>
              </b-card>
              <ResponseInfo v-if="getResponseInfo.responseName == 'sendDisputeModal'"></ResponseInfo>
              <div class="col-12 mt-2" v-if="incorrectDocument">{{ t('disputeCreationForbiddenForDoc', 'disputeCreationForbiddenForDoc') }}</div>
            </template>
            <template v-else>
              <h5 class="text-danger text-center"><fontAwesomeIcon :icon="['fas', 'exclamation-triangle']" size="1x" class="mr-2"/> {{t('noDocsSelected','noDocsSelected')}}</h5>
              <p class="text-danger text-center">{{t('pleaseSelectDocsFirst','pleaseSelectDocsFirst')}}</p>
            </template>
          </div>
        </div>
      </div>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel }">
      <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
        <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('cancelAndCloseButtonText', 'cancelAndCloseButtonText')}}
      </button>
      <template v-if="queryModal.docuData.docsChecked.length">
        <b-button v-if="!buttonIsBusy" aria-label="sendDispute" data-dismiss="modal" variant="primary" type="button" @click="sendDispute()" :disabled="!selectedDisputeStatus || !selectedDoc || !disputeNote || checkMissingAdditionalInfo">{{ t('sendDisputeBtnText', 'sendDisputeBtnText')}}</b-button>
        <b-button v-else-if="buttonIsBusy" variant="primary" type="button" disabled>
          <b-spinner small type="grow"></b-spinner>
          {{ t('sendDisputeBtnText','sendDisputeBtnText') }}
        </b-button>
      </template>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import datePicker from 'vue-bootstrap-datetimepicker'
import ResponseInfo from '@/components/ResponseInfo.vue'
import Loading from 'vue-loading-overlay'

export default {
  name: 'ModalSendDispute',
  //this component inherits from the Search.vue component
  inject: [
    'resetModal',
    'getModalLevel',
    'searchDocuments'
  ],
  data () {
    return {
      loaderBusy: true,
      modalIsBusy: true,
      buttonIsBusy: false,
      disputeStatuses: null,
      selectedDoc: null,
      selectedDisputeStatus: null,
      disputeNote: null,
      buttonIsBusy: false,
      additionalInfo1: null,
      additionalInfo2: null,
      additionalInfo3: null,
      reqAdditionalInfo1: false,
      reqAdditionalInfo2: false,
      reqAdditionalInfo3: false,
      incorrectDocument: false,
      datePickerConfig: {
        icons: {
          time: 'os-icon os-icon-calendar-time',
          date: 'os-icon os-icon-basic-2-259-calendar',
          up: 'os-icon os-icon-chevron-up',
          down: 'os-icon os-icon-chevron-down',
          previous: 'os-icon os-icon-chevron-left',
          next: 'os-icon os-icon-chevron-right',
          clear: 'os-icon os-icon-trash',
          close: 'os-icon os-icon-cancel-circle'
        },
        //format: 'DD/MM/YYYY'
        format: this.datePickerFormat,
        maxDate: moment(new Date(), this.datePickerFormat),
        showClear: true
      },
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo','getUserDetails']),
    documents() {
      return this.$store.getters['documentsStore/getDocuments']
    },
    queryModal: {
      get:function(){
        return this.$attrs.modal
      },
      set:function(d){
        this.queryModal = d
      }
    },
    checkMissingAdditionalInfo() {
      // true = block button
      // false = don't block submit button
      if(this.reqAdditionalInfo1 && !this.additionalInfo1) {
        return true
      }

      if(this.reqAdditionalInfo2 && !this.additionalInfo2) {
        return true
      }

      if(this.reqAdditionalInfo3 && !this.additionalInfo3) {
        return true
      }

      if(this.incorrectDocument) {
        return true
      }

      return false
    },
    datePickerFormat() {
      if(this.$store.getters.allTemplateDetails && this.$store.getters.allTemplateDetails.datePickerFormat) {
        let dateformat = this.$store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, '/')
        return dateformat
      } else {
        return "DD-MM-YYYY"
      }
    }
  },
  methods: {
    checkDisputeRequirements() {
      let requiredInfo1 = [2, 4, 7, 10, 11]
      let requiredInfo2 = [7, 10]
      let requiredInfo3 = 7

      if(requiredInfo1.includes(this.selectedDisputeStatus)) {
        this.reqAdditionalInfo1 = true
      } else {
        this.reqAdditionalInfo1 = false
      }

      if(requiredInfo2.includes(this.selectedDisputeStatus)) {
        this.reqAdditionalInfo2 = true
      } else {
        this.reqAdditionalInfo2 = false
      }

      if(this.selectedDisputeStatus == 7) {
        this.additionalInfo2 = moment(new Date(), this.datePickerFormat)
        this.reqAdditionalInfo3 = true
      } else {
        this.reqAdditionalInfo3 = false
      }

      if(this.selectedDoc.substring(0, 3) != 'SCN') {
        this.incorrectDocument = true
      } else {
        this.incorrectDocument = false
      }
    },
    clearResponseMessage() {
      this.$store.dispatch('alertClearResponse')
    },
    setSelectedDoc(docReference, docId) {
      this.selectedDoc = docReference
      this.docId = docId

      if(docReference.substring(0, 3) != 'SCN') {
        this.incorrectDocument = true
      } else {
        this.incorrectDocument = false
      }

      // on document change we clear the additional field info
      this.additionalInfo1 = null
      this.additionalInfo2 = null
      this.additionalInfo3 = null
    },
    setFirstDocument() {
      // upon opening modal we also set the first doc id as the selected one
      if(this.queryModal.docuData.statuses && this.queryModal.docuData.statuses.length) {
        this.setSelectedDoc(this.queryModal.docuData.statuses[0].reference, this.queryModal.docuData.docsChecked[0])
      }
    },
    getDisputeStatuses() {
      this.$store.dispatch('disputeStore/getDisputeStatuses', null)
      .then(response => {
        this.disputeStatuses = response.statuses
        this.modalIsBusy = false
      })
    },
    clearModal() {
      this.formData = {
        general: {}
      }
      this.tooltipTargets = []
    },
    loaderStopped() {
      this.loaderBusy = false
    },
    sendDispute() {
      this.buttonIsBusy = true

      if(this.selectedDisputeStatus == 7 && this.additionalInfo2) {
        this.additionalInfo2 = moment(this.additionalInfo2).format('DD/MM/YYYY')
      }

      this.$store.dispatch('disputeStore/sendDispute', {
        docId: this.docId,
        disputeStatus: this.selectedDisputeStatus,
        disputeNotes: this.disputeNote,
        disputeInfo1: this.additionalInfo1,
        disputeInfo2: this.additionalInfo2,
        disputeInfo3: this.additionalInfo3
      })
      .then(() => {
        this.buttonIsBusy = false
        this.selectedDisputeStatus = null
        this.disputeNote = null
        this.additionalInfo1 = null
        this.additionalInfo2 = null
        this.additionalInfo3 = null
      })
    }
  },
  created() {
    this.datePickerConfig.format = this.datePickerFormat
  },
  filters:{
    humanReadable: function(date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    }
  },
  components:{
    ResponseInfo,
    Loading,
    datePicker
  }
}
</script>

<style scoped>
.button-h {
  max-height: 30px;
}
.modal-open #queryModal___BV_modal_outer_ >>> .modal-dialog{
  display: flex !important;
  justify-content: center !important;
}
/*main modal level*/
.modal-open #queryModal___BV_modal_outer_ >>> .modal-content{
  min-width: 850px !important;
  max-width: auto !important;
  width: auto !important;
}
.modal-open #queryModal___BV_modal_outer_ >>> .modal-content .modal-body{
  max-height: 520px;
  overflow-y: scroll;
}
/*sub modal level*/
.modal-open #subQueryModal___BV_modal_outer_ >>> .modal-content{
  min-width: 850px !important;
  max-width: auto !important;
  width: auto !important;
}
.modal-open #subQueryModal___BV_modal_outer_ >>> .modal-content .modal-body{
  max-height: 520px;
  overflow-y: scroll;
}
.doc-list {
  width: 300px;
  height: 250px;
  overflow: auto;
}
.nav-link >>> .doc-button{
  border-radius: 0 !important;
}
</style>
